import i18n from 'i18next'
import { LanguageCode, normalizeLanguage } from './languages'

/**
 * Light helpers that read the interface language without pulling in the i18n setup (axios, the
 * store). The pseudo-locale reads as English. Safe to call before i18n has initialised.
 */

// Set synchronously by setLanguage, before the new language's strings have loaded.
let requested: string | undefined

export const noteRequestedLanguage = (language: string) => {
  requested = language
}

/** The language the interface is showing now. Use it for formatting next to translated copy. */
export const currentLanguage = (): LanguageCode => normalizeLanguage(i18n.language || requested)

/** The locale for Intl formatters: the interface language, English for the pseudo-locale. */
export const currentLocale = (): string => currentLanguage()

/** The language the learner asked for, even if its strings are still loading. For analytics. */
export const requestedLanguage = (): LanguageCode => normalizeLanguage(requested || i18n.language)

/** PostHog super properties. Registered when PostHog loads and on every language change. */
export const languageSuperProperties = () => ({ ui_language: requestedLanguage() })
